export default __webpack_public_path__ + "static/media/users-icon.9896b466.svg";